export default __webpack_public_path__ + "5885feb264991825e67f6bdda2b67c3b.ttf";